
export const reverseEnum = <TEnum>(enumeration: TEnum) =>
  Object.entries(enumeration)
    .map(([key, value]) => ({[value]: key}))
    .reduce((prev, curr) => ({...prev, ...curr}));
